// Arranque de la invitación al equipo (WAYAK #844 / CC-CONSOLE#1512).
//
// DEBE ser el PRIMER import de main.tsx. La liga `/register?invite=<token>`
// trae una credencial en la URL, y la analítica (Sentry / PostHog) lee
// `window.location` en cuanto arranca: el token saldría en su primer evento.
// Importar este módulo lo guarda y lo quita de la barra de direcciones de forma
// síncrona, antes de que corra una sola línea de la analítica.
//
// Sólo depende de utils/teamInvite (que no depende de nada). En WAYAK este
// trabajo lo hace utils/demoInviteBoot, que además atiende las cuentas demo;
// CC-CONSOLE no tiene cuentas demo.
import { captureAndStripInviteToken } from "./teamInvite";

captureAndStripInviteToken();
